export default __webpack_public_path__ + "static/media/founding-member-gold.86edf096.png";